import React from "react";
import ContactUsRedesign from "../redesign/ContactUsRedesign";

const ContactUs = () => {
  return <ContactUsRedesign />;
};

export default ContactUs;
